export const fetchRecurringCharges = () => {
  return(dispatch, getState) => {
    const state = getState()
    const { name } = state.organization
    const { id } = state.resident
    
    dispatch({type: 'BEGIN_FETCH_RECURRING_CHARGES'})
    $.ajax({
      url: `/organizations/${name}/residents/${id}/recurring_charges.json`,
      success: (response) => {
          dispatch({ type: 'SUCCESS_FETCH_RECURRING_CHARGES', payload: response })
      },
      error: (XMLHttpRequest, textStatus, errorThrown) => {
          dispatch({ type: 'FAILED_FETCH_RECURRING_CHARGES', payload: { error: { errorThrown } } })
      }
    })
  }
}